import OktaSignIn from '@okta/okta-signin-widget';
import oktaConfig from 'config/okta';
import { env } from 'env';

enum ResponseModeType {
  Query = 'query',
  Fragment = 'fragment',
}

const { pkce, issuer, clientId, redirectUri, scopes } = oktaConfig.oidc;

const oktaSignIn = new OktaSignIn({
  clientId,
  redirectUri,
  baseUrl: issuer.split('/oauth2')[0],
  authParams: {
    pkce,
    issuer,
    display: 'page',
    responseMode: pkce ? ResponseModeType.Query : ResponseModeType.Fragment,
    scopes,
  },
  i18n: {
    en: {
      'primaryauth.username.placeholder': 'Email',
      'primaryauth.username.tooltip': 'Email',
      'primaryauth.title': 'Sign in to your account',
      forgotpassword: 'Forgot Password? Click Here.',
      'errors.E0000004': 'Invalid username or password.  Your username is your email address used during enrollment.',
      'error.auth.lockedOut': 'Due to multiple invalid attempts, your account is temporarily locked.',
      'error.username.required': 'Please enter your email address',
      'oform.errorbanner.title': 'We found some errors. Please review and make corrections',
      'password.forgot.emailSent.desc': `Once we confirm {0} matches our records, we will send you an email with a password recovery link. It should arrive within a few minutes. If you don’t receive the email, try these steps. 1) Check your spam folder. 2) Ensure ${env.REACT_APP_REPUBLIC_FINANCE_EMAIL} is on your safe list.`,
      'password.complexity.symbol': 'a special character',
      'rememberDevice.devicebased': 'Remember this Device',
    },
  },
});

export default oktaSignIn;
